import type { WordDocumentContext } from "../types";
import styles from "./WordDocBanner.module.css";

interface WordDocBannerProps {
  readonly doc: WordDocumentContext;
  readonly loading: boolean;
  readonly onRefresh?: () => void;
}

function describeWordCount(wordCount: number, loading: boolean): string {
  if (wordCount > 0) return `${wordCount} words`;
  if (loading) return "Reading…";
  return "Empty document";
}

export function WordDocBanner({ doc, loading, onRefresh }: Readonly<WordDocBannerProps>) {
  const name = doc.name || "Untitled Document";
  const info = describeWordCount(doc.wordCount, loading);

  return (
    <section className={styles.banner} aria-label="Word document context">
      <div className={styles.text}>
        <span className={styles.name} title={name}>{name}</span>
        <span className={styles.info}>{info}</span>
      </div>
      {onRefresh && (
        <button type="button" className={styles.refresh} onClick={onRefresh} disabled={loading}>
          Refresh
        </button>
      )}
    </section>
  );
}
